module.exports = __webpack_public_path__ + "img/portique_PMK.673a4eaa.jpg";